<div class="app">
  <div class="app__header">
    <iaud-header [sidenav]="sidenav"></iaud-header>
  </div>
  <mat-sidenav-container class="app__sidenav">
    <mat-sidenav class="app__sidenav__menu" #sidenav>
      <iaud-menu></iaud-menu>
    </mat-sidenav>
    <mat-sidenav-content class="app__sidenav__content">
      <div>
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
